export default {"src":"/_next/static/media/payment-maestro.eb305bb1.svg","height":30,"width":44,"blurWidth":0,"blurHeight":0};